import type { VoidFunctionComponent } from 'react';

import NotFound from '../generic/NotFound';
import { userHasIssueOverviewPermissions } from '../issueOverview/accessControl';
import IssueOverview from '../issueOverview/IssueOverview';

import IssuesInbox from './IssuesInbox';
import type { IssuesContainerProps } from './IssuesContainer';

/**
 * Component to wrap routing for the route of the issues project subnav. If the org
 * has issues overview enabled and the user has permission to access it for this project,
 * it will show as a the root page. Otherwise it will render the issues inbox for the project.
 */
const ProjectIssuesRouteContainer: VoidFunctionComponent<IssuesContainerProps> = ({
  location,
  params,
  project,
  revision,
  router,
}) => {
  const projectLocator = project?.data?.locator;

  const doesUserHaveAccessToIssueOverviewForProject =
    projectLocator === null || userHasIssueOverviewPermissions(projectLocator);

  const isOverviewRoute = location.pathname.endsWith('/issues/overview');

  if (isOverviewRoute) {
    if (!doesUserHaveAccessToIssueOverviewForProject) {
      return <NotFound />;
    }

    return <IssueOverview />;
  }

  return <IssuesInbox location={location} params={params} project={project} revision={revision} router={router} />;
};

export default ProjectIssuesRouteContainer;
